import { useLoaderData } from 'react-router';

import type { loader } from '~/routes/_app.product.$urlSegment';
import { DetailHero } from '~/ui-rocco/pages/detail-shared';
import { PRODUCT_HERO_CTA_SLOT_ID } from '../product-hero-cta-slot';

/**
 * F2 — product hero / title. Maps the product loader into the shared
 * {@link DetailHero} (text variant — the logomark comes from the unified
 * header). Brand eyebrow falls back from the professional name to the brand.
 */
export const ProductHeroSection = () => {
    const { product } = useLoaderData<typeof loader>();
    const professional = product.Professional;
    const brand = professional?.Title ?? product.Brand ?? '';

    return (
        <DetailHero
            eyebrow={brand ? `(${brand})` : undefined}
            // Link the eyebrow to the professional only when it is their name.
            eyebrowLink={professional?.Title ? professional.Link : undefined}
            title={product.Title}
            // Compact title scale so the gallery — the page's real hero and
            // the morph destination — sits higher in the fold.
            compact
            titleActionsSlotId={PRODUCT_HERO_CTA_SLOT_ID}
            showBackButton
            // Landed here directly? Back goes to the category the product sits
            // in rather than nowhere.
            backFallbackHref={product.Categories?.[0]?.Link ?? '/products'}
        />
    );
};
